import { EButtonModifier } from "@karma-games/angular-devkit/src/lib/modules/button";
import { IStepperConfig, SelectComponent } from "@karma-games/angular-devkit/modules/controls-components";
import IOption = SelectComponent.IOption;
import { IAutoplayOptionsConfig } from "../core/config/interfaces";
import { Observable } from 'rxjs';

export enum EBetButtonState {
    BetNotPrepared = "betNotPrepared",
    BetPrepared = "betPrepared",
    NoBet = "noBet",
    Betted = "betted",
    RoundPlaying = "roundPlaying"
}

export enum EBetPanelTab {
    Bet = "bet",
    AutoBet = "autoBet"
}

export interface IBetPanelData {
    predefinedBetOptions: IOption<number>[];
    betStepperConfig: IStepperConfig | undefined;
    multiplierStepperConfig: IStepperConfig | undefined;
    autoplayConfig: IAutoplayOptionsConfig | undefined;
}

export interface IBetPanelAccumulatedValueData {
    accumulatedAmount: number | undefined;
    roundId: string | undefined;
    multiplier: number | undefined;
    autoplayRoundCount: number | undefined;
    firstHalfCashedOut: number | undefined;
}

export interface IBetButtonState extends IBetPanelAccumulatedValueData {
    stateName: EBetButtonState;
    buttonModifier: EButtonModifier;
    textKey: string;
    showAmountInText: boolean;
    actionInProgress: boolean;
}

export interface IAutoPlayRepository {
    getUserWallet(): Observable<number>;
}

export enum EAutoplayStopReason {
    RoundCount,
    CashDecrease,
    CashIncrease,
    SingleWinAmountExceed
}

export interface IAutoplayStopData {
    reason: EAutoplayStopReason;
    data: number[];
}
